import { type ChangeEvent, useRef } from 'react'

import style from './FilePicker.module.scss'

interface IProps {
    title: string
    className: string
    onHandleFile: (uploadedFile: File) => void
    additionalCallback?: () => void
}

export const FilePicker = (props: IProps) => {
    const { title, className, onHandleFile, additionalCallback } = props

    const hiddenFileInput = useRef<HTMLInputElement | null>(null)

    const onTitleClick = () => {
        if (hiddenFileInput.current) {
            hiddenFileInput.current.click()
        }
    }

    const onHandleChange = (event: ChangeEvent<HTMLInputElement>) => {
        event.preventDefault()

        if (event.target.files) {
            const fileUploaded = event.target.files[0]
            onHandleFile(fileUploaded)
        }

        additionalCallback?.()
    }

    return (
        <>
            <span className={className} onClick={onTitleClick}>
                {title}
            </span>
            <div className={style.container}>
                <input type='file' ref={hiddenFileInput} onChange={onHandleChange} />
            </div>
        </>
    )
}
